import React from "react";

function InventoryIntegration() {
  return (
    <div className="overflow-scroll mt-2">
      <div className="max-h-[28rem] text-[12px] mr-3">
        <h1 className="font-bold">※ 재고 연동하기 - 사용 안내 </h1>
        <h3 className="mt-4 font-bold">1. 스마트팩토리의 재고 연동하기</h3>
        <ol className="mt-4">
          <li>
            (1) 최초 [API 연동하기] → [스마트팩토리 API - 일괄 재고 연동하기]
            <p>① 방법 1</p>
            <ul>
              <li>
                <ul>
                  <li>
                    → 재고관리에서 '스마트팩토리 업데이트 재고 확인' 에서{" "}
                    <span className="text-secondary-blue">
                      'API 연동완료' 된 재고정보
                    </span>
                    에 한하여,{" "}
                    <span className="text-secondary-red">
                      '일괄 재고 연동하기'가 가능
                    </span>
                    합니다.
                  </li>
                  <li>
                    → API 미연동 재고는{" "}
                    <span className="text-secondary-red">'API 연동하기'</span>를
                    눌러{" "}
                    <span className="underline">'스마트팩토리 연동 등록'</span>{" "}
                    팝업에서 연동해주세요.
                  </li>
                </ul>
              </li>
              <li>
                ② 방법 2
                <ul>
                  <li>
                    → 상품관리 &gt; 코드관리 &gt; REF 관리 &gt; QR 정보 상세에서
                    '스마트팩토리 연동 등록'을 먼저 합니다.
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <h1 className="font-bold mt-4">
              ☞ 스마트팩토리 연동 경우의 항목 설명
            </h1>
            <ul>
              <li>* 입고수량 : 스마트팩토리에 등록된 입고수량</li>
              <li>
                * [연동] 현재 재고수량 : 연동 완료 이후에 재고가 사용된 잔여수량
              </li>
              <li>
                * 스마트팩토리 미연동 상태에서 [연동] 현재 재고수량이
                &apos;0&apos;인 경우?
              </li>
              <li>
                - &apos;일괄 재고 연동하기&apos; 를 눌러야만 입고수량과 [연동]
                현재 재고수량 최초값이 등록됩니다.
              </li>
              <li>
                * 연동완료 상태에서 [연동] 현재 재고수량이
                &apos;입고수량&apos;과 다르고 &apos;0&apos;인 경우?{" "}
              </li>
              <li>
                - 연동완료 된 이후에 재고를 사용하고 남은 해당 QR 정보의 잔여
                재고 수량을 의미합니다. &apos;0&apos;인 경우는 실제 서버에
                재고가 &apos;0&apos;을 의미합니다. 이 경우, 주문배송을 위한
                배송출고 및 기타 출고 처리가 불가능합니다.
              </li>
            </ul>
          </li>
        </ol>
        <h3 className="mt-6 mb-4 font-bold">
          2. LOT 신규 생성한 재고 연동하기 - 수동 등록
        </h3>

        <ul>
          <li>(1) 최초 등록 방법</li>
          <li>
            상품관리 &gt; 코드관리 &gt; REF 관리 &gt; QR 정보 상세에서{" "}
            <span className="text-secondary-blue">
              &apos;+LOT 신규 생성&apos;
            </span>
            을 합니다.
          </li>
          <li className="mt-4">(2) 재고를 연동하는 방법</li>
          <li>
            * 접근 방법 1. 코드관리 &gt; REF 관리 &gt; QR 정보 상세에서
            &apos;재고 상세내역 이동&apos; 버튼 클릭 →{" "}
            <span className="text-secondary-blue">LOT 재고 연동 클릭</span>
          </li>
          <li>
            * 접근 방법 2. 상품관리 &gt; 재고관리의 해당 REF 재고 상세내역에서
            <span className="text-secondary-blue">
              &apos;LOT 재고 연동&apos;
            </span>{" "}
            클릭
          </li>
        </ul>
        <ol className="mt-4">
          <ul>
            <li>
              ▣ 1단계 : 목록에서 &apos;수동 등록&apos; 미연동 된 QR 정보를 확인
              후,{" "}
              <span className="text-secondary-red">
                &apos; 재고연동 하기&apos;
              </span>{" "}
              버튼을 클릭 →{" "}
              <span className="text-secondary-red">
                &apos;수동 등록 - LOT 재고 연동&apos;
              </span>{" "}
              팝업 열림
            </li>
            <li className="mt-4">▣ 2단계 : QR 스캔 결과, 입고수량 입력하기</li>
            <li>
              ① QR 스캔을 누룬 후, USB 바코드 스캐너를 통하여 &apos;입고 상품의
              QR&apos;을 스캔해주세요.
            </li>
            <li>
              ② QR 스캔이 일치되면, 코드관리-QR 정보 상세에 등록한 LOT 정보가
              <span className="text-secondary-blue">
                &apos;QR 스캔 정보&apos;
              </span>
              에 나옵니다.
            </li>
            <li>
              ③ <span className="text-secondary-red">입고수량</span>을 정확히
              입력해주세요.
            </li>
            <li>
              ④ 입고된 수량을 잘못 입력할 경우,{" "}
              <span className="text-secondary-blue">
                &apos;재고 수동 변경&apos;
              </span>
              을 통해 재고 수량을 조정할 수 있습니다.
              <span> 단, 현재 단계에서 신중히 입력 부탁드립니다.</span>
            </li>
            <li>
              ⑤{" "}
              <span className="text-secondary-red">&apos;연동 완료&apos;</span>{" "}
              버튼을 누르면, 서버와 상세내역에 입고수량이 등록됩니다.
            </li>
          </ul>
        </ol>
        <h3 className="mt-4 font-bold">☞ 수동 등록 연동 경우의 항목 설명</h3>
        <ul>
          <li>* 입고수량 : 수동 등록 연동하기에에 등록된 입고수량</li>
          <li>
            * [연동] 현재 재고수량 : 연동 완료 이후에 재고가 사용된 잔여수량
          </li>

          <li>
            * 수동 등록 미연동 상태에서 [연동] 현재 재고수량과 입고수량이
            &apos;0&apos;인 경우?
          </li>
          <li>
            - 미연동 상태에서는 입고수량을 아직 연동하지 않았기때문에 입고수량이
            &apos;0&apos;으로 표시됩니다.
          </li>
          <li>
            - 연동하기 1단계, 2단계 방법을 통하여 연동 완료할 경우, 입고수량과
            [연동] 현재 재고수량 최초값이 등록됩니다.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default InventoryIntegration;
